import { CircularProgress } from '@material-ui/core'
import React from 'react'

function Loader({ open, fullPage }) {
  if (fullPage) {
    return open ? (
      <div className="loader-overlay">
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      </div>
    ) : (
      <></>
    )
  } else {
    return (
      open && (
        <div
          style={{
            width: '100%',
            zIndex: 1000,
            margin: 0,
          }}
        >
          <CircularProgress style={{ color: '#000846' }} />
        </div>
      )
    )
  }
}

export default Loader
